export default async function onReady () {
    return new Promise((resolve, reject) => {
        // Check for document.readySt
        document.readyState || reject(new Error("can't resolve readystate from document."))

        let listener
            ; /d$|^i|^c/.test(document.readyState)
                ? resolve()
                : window.addEventListener(
                    'DOMContentLoaded',
                    (listener = event => {
                        document.removeEventListener('DOMContentLoaded', listener)
                        resolve()
                    }),
                )
    })
}
